'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".BlockButton-module_button__0m7W2{background-color:#2b7cac;border:.0625rem #2b7cac;border-radius:.125rem;color:#fff;cursor:pointer;display:inline-block;font-family:inherit;font-size:.875rem;font-weight:700;height:auto;line-height:1.25rem;margin:0;min-width:6.25rem;padding:.625rem 1.5rem;position:relative;text-align:center;-webkit-text-decoration:none;text-decoration:none}.BlockButton-module_buttonOutline__tN-gZ{background-color:transparent;border:1px solid #2b7cac;color:#2b7cac}@media (hover:none) and (pointer:coarse){.BlockButton-module_button__0m7W2{padding:.75rem 1.5rem}}";
var styles = {"button":"BlockButton-module_button__0m7W2","buttonOutline":"BlockButton-module_buttonOutline__tN-gZ"};
styleInject["default"](css_248z, '53b07741-8149-45f9-b925-3da6b9c8bbbd');

exports["default"] = styles;
